
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="link-container">
    @if (navigationItem.pageLinksCollection?.items.length > 1) {
        <div class="link has-dropdown" [ngClass]="{ active: activeItem === navigationItem.navigationTitle }">
            <button class="menu-with-icon">
                <span>
                    {{ navigationItem.navigationTitle }}
                </span>
            </button>
        </div>
    } @else {
        <div class="link no-dropdown" [ngClass]="{ active: activeItem === navigationItem.navigationTitle }">
            <ng-container *ngIf="navigationItem.pageLinksCollection?.items[0] as item">
                <lib-link *ngIf="item.linkTitle && (item.internalLink?.url || item.externalLink || item.docLink || item.jumpTarget)"
                [childClass]="'main-nav-link ' + linkType" [internalLink]="item.internalLink?.url" [linkTitle]="navigationItem.navigationTitle"
                [target]="item.linkTarget" [externalLink]="item.externalLink" [documentLink]="item.docLink" [fragment]="item.jumpTarget">
                </lib-link>
            </ng-container>
            <ng-template #mainNavItem>
                <span>{{navigationItem.navigationTitle}}</span>
            </ng-template>
        </div>
    }
    @if (navigationItem.pageLinksCollection?.items.length > 1 && !navigationItem.isMegaMenu || !isDesktopUp) {
        <div class="nav-menu" [ariaHidden]="navigationItem.navigationTitle !== activeItem"
            [ngClass]="{menuActive:navigationItem.navigationTitle === activeItem}">
            <ng-container *ngFor="
            let item of navigationItem.pageLinksCollection.items;
            let i = index
            ">
                <div class="nav-menu-item">
                    <lib-link *ngIf="item.linkTitle && (item.internalLink?.url || item.externalLink || item.docLink || item.jumpTarget)"
                        [childClass]="linkClass" [internalLink]="item.internalLink?.url" [linkTitle]="item.linkTitle"
                        [target]="item.linkTarget" [externalLink]="item.externalLink" [documentLink]="item.docLink" [fragment]="item.jumpTarget">
                    </lib-link>
                </div>
            </ng-container>
        </div>
    } @else if (navigationItem.navigation?.length > 1 && navigationItem.isMegaMenu) {
        @if (!isBrowser) {
            <!-- SSR: lightweight flat links for SEO -->
            <nav class="mega-menu-seo" ngSkipHydration aria-hidden="true" [attr.aria-label]="navigationItem.navigationTitle" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);">
                <ul>
                    @for(item of navigationItem.navigation; track $index) {
                        @if (item.fields?.linkTitle && item.fields?.internalLink?.url) {
                            <li><a [href]="'/' + item.fields.internalLink.url" tabindex="-1">{{item.fields.linkTitle}}</a></li>
                        }
                        @if (item.subNavs?.submenuList) {
                            @for(section of item.subNavs.submenuList; track $index) {
                                @for(link of section.links; track $index) {
                                    @if (link.linkTitle && link.internalLink?.url) {
                                        <li><a [href]="'/' + link.internalLink.url" tabindex="-1">{{link.linkTitle}}</a></li>
                                    } @else if (link.linkTitle && link.externalLink) {
                                        <li><a [href]="link.externalLink" tabindex="-1">{{link.linkTitle}}</a></li>
                                    }
                                }
                            }
                        }
                    }
                </ul>
            </nav>
        } @else {
        <div class="mega-menu" *ngIf="navigationItem.navigation?.length > 1" (click)="handleInsideClick($event)" [ngClass]="{menuActive:navigationItem.navigationTitle === activeItem}">
            <a role="button" class="close-btn" aria-label="Close Search" tabindex="0" (click)="close($event)" (keypress)="close($event)"><i class="fal fa-times"></i></a>
            <div class="menu-container">
                <div class="left">
                    <ng-container *ngFor="let item of navigationItem.navigation; let i = index">
                        <div class="inner-nav-menu-item" [class.active]="selectedChildMenuItem.fields?.linkTitle === item.fields?.linkTitle" [ngClass]="item.fields?.cssClass"> 
                            @if (item.subNavs?.submenuList?.length > 0) {
                                <div class="nav-menu-item-drill-down">
                                    <button type="button" (click)="selectSubMenu($event, item)" *ngIf="item?.fields?.linkTitle">{{item.fields?.linkTitle}}</button>
                                </div>
                            } @else {
                                <lib-link *ngIf="item.fields?.linkTitle"
                                [childClass]="linkClass" [internalLink]="item.fields?.internalLink?.url" [linkTitle]="item.fields?.linkTitle"
                                [target]="item.fields?.linkTarget" [externalLink]="item.fields?.externalLink" [documentLink]="item.fields?.docLink" [fragment]="item.fields?.jumpTarget">
                                </lib-link>
                            }
                        </div>
                    </ng-container>
                </div>
                
                @for(menuitem of navigationItem.navigation; track $index+'-first-level') {
                    <div class="right White" [class.active]="selectedChildMenuItem.fields?.linkTitle === menuitem.fields?.linkTitle">
                        @if (menuitem.subNavs?.submenuList) {
                            <div class="nav-content-wrapper">
                            
                                @if(menuitem.subNavs?.menuTxt || menuitem.subNavs?.menuBtn )  {
                                    <div class="nav-info-header" >
                                        @if(menuitem.subNavs?.menuTxt) {<div class="info-text">{{menuitem.subNavs?.menuTxt}}</div>}
                                        @if(menuitem.subNavs?.menuBtn) {
                                            <lib-link [childClass]="'btn secondary-button'"
                                                [internalLink]="menuitem.subNavs?.menuBtn?.internalLink?.url"
                                                [linkTitle]="menuitem.subNavs?.menuBtn?.linkTitle"
                                                [target]="menuitem.subNavs?.menuBtn?.linkTarget"
                                                [externalLink]="menuitem.subNavs?.menuBtn?.externalLink"
                                                [documentLink]="menuitem.subNavs?.menuBtn?.docLink"
                                                [fragment]="menuitem.subNavs?.menuBtn?.jumpTarget">
                                            </lib-link>
                                        }
                                    </div>
                                    <div  class="line-break"></div>
                                }
                                <div class="nav-columns" [class.d-flex]="menuitem.subNavs?.submenuList?.length <= 2">
                                @for(thirdMenuItem of menuitem.subNavs?.submenuList; let index = $index; track trackByUniqueId(index, thirdMenuItem)) {
                                        <div class="nav-info-section" [class.border]="menuitem.subNavs?.submenuList?.length > 2">
                                            <div class="nav-item-header">{{thirdMenuItem.title}}</div>
                                            <ul>
                                                @for(subMenuItem of thirdMenuItem.links; let subIndex = $index; track trackByUniqueId(subIndex, subMenuItem)) {
                                                    <li class="menu-item">
                                                        <lib-link *ngIf="subMenuItem.linkTitle && (subMenuItem.internalLink?.url || subMenuItem.externalLink || subMenuItem.docLink || subMenuItem.jumpTarget)"
                                                            [childClass]="linkClass" [internalLink]="subMenuItem.internalLink?.url" [linkTitle]="subMenuItem.linkTitle"
                                                            [target]="subMenuItem.linkTarget" [externalLink]="subMenuItem.externalLink" [documentLink]="subMenuItem.docLink" [fragment]="subMenuItem.jumpTarget">
                                                        </lib-link>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    <lib-link class="menu-item" *ngIf="thirdMenuItem.linkTitle && (thirdMenuItem.internalLink?.url || thirdMenuItem.externalLink || thirdMenuItem.docLink || thirdMenuItem.jumpTarget)"
                                        [childClass]="linkClass" [internalLink]="thirdMenuItem.internalLink?.url" [linkTitle]="thirdMenuItem.linkTitle"
                                        [target]="thirdMenuItem.linkTarget" [externalLink]="thirdMenuItem.externalLink" [documentLink]="thirdMenuItem.docLink" [fragment]="thirdMenuItem.jumpTarget">
                                    </lib-link>
                                }
                                </div>

                            </div>
                        }
                    </div>
                }
            </div>
        </div>
        }
    }
       
</div>